// extracted by mini-css-extract-plugin
export default {"alertaFixo":"Alerta_alertaFixo__PDJzV"};